export const SUPPORT_ROUTES = {
  INBOX: '/admin/support/tickets',
  TICKET_DETAIL: '/admin/support/tickets/:id',
} as const;

export const supportTicketDetailUrl = (id: string): string =>
  `/admin/support/tickets/${id}`;
